import Prefixer from 'inline-style-prefixer';

import { colors } from '@ublend-npm/aulaui-next-web/themes/default';
import fonts from '../../../../../styles/fonts';

const style = new Prefixer().prefix({
  container: {
    display: 'flex',
    flexDirection: 'column',
    ...fonts.light,
    backgroundColor: 'white',
    border: `1px solid ${colors.grey3}`,
    padding: 30,
    borderRadius: '5px',
  },
  image: {
    width: 50,
    paddingRight: 24,
  },
  titleRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
  },
  title: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    color: colors.grayDark,
    fontSize: 26,
    marginBottom: 25,
  },
  titleText: {
    lineHeight: '40px',
    display: 'block',
  },
  titleEmphasised: {
    color: 'black',
  },
  description: {
    display: 'flex',
    flexDirection: 'row',
    fontSize: 16,
    color: colors.grey6,
    lineHeight: '24px',
  },
  descriptionSplitContainer: {
    maxWidth: 300,
    minWidth: 263,
    paddingRight: 70,
  },
  descriptionTitle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    fontSize: 16,
    marginBottom: 20,
    minHeight: 50,
    marginTop: 25,
  },
  descriptionTitleImage: {
    width: 50,
    display: 'block',
    marginRight: 17,
  },
  descriptionText: {
    fontSize: 14,
  },
  dismiss: {
    color: colors.grey4,
    fontSize: 20,
    cursor: 'pointer',
  },
});

export default style;
